import { yupResolver } from '@hookform/resolvers/yup';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

import { gridSizeMdLg6, ROUTER_PATHS } from '@/shared';

import { CreateObservacionParams, useCreateObservación } from '@/shared/actions/erp'

import {
	CustomTextField,
	SingleFormBoxScene,
	CustomAutocomplete,
} from '@/shared/components/ui';
import { Observacion } from '@/shared/interfaces';
import { UseFetchResponsablev2 } from '@/shared/actions/erp/responsablev2.actions';
import { useUpdateObservacion } from '@/shared/actions/erp/observacion.action'
import { Responsablev2 } from '@/shared/interfaces/erp/administration/responsablev2.interface';
import { newObservacionSchema } from '@/shared/utils';



export type SaveObservacionInterface = {
	titlePage: string;
	observacionEditar?:Observacion;
};
export type SaveFormData = CreateObservacionParams;

const SaveObservacion: React.FC<SaveObservacionInterface> = ({titlePage, observacionEditar}) => {

	const navigate = useNavigate();
	const [shrink, setShrink] = useState(false);
	const returnUrlObservaciones = ROUTER_PATHS.administration.observacionNav;
	///* mutations
	const createObservacionMutation = useCreateObservación({
		navigate,
		returnUrl: returnUrlObservaciones,
		enableErrorRedirect: false,
	});
	const  updateObservacionMutation =useUpdateObservacion(navigate,returnUrlObservaciones);
	///TRAEIDA DE INFORMACION DE RESPONSABLE
	const {data: responsablePaginRes, isLoading} = UseFetchResponsablev2();

	///FORMULARIO
	const form = useForm<SaveFormData>({
		resolver: yupResolver(newObservacionSchema) as any,
		defaultValues: {
			estado: true,
		},
	});
	

	const {
		handleSubmit,
		reset,
		formState: { errors, isValid },
	} = form;


	
	

	const onSave = () => {
		if (!isValid) return ;
		console.log(form.getValues());
		//edit
		if(observacionEditar?.id_observacion){
			return updateObservacionMutation.mutate({
				id:observacionEditar.id_observacion,
				data: form.getValues() as any,
			});
		}
		//create
		return createObservacionMutation.mutate({
			...form.getValues(),
		});
	};

	useEffect(()=>{
		if(observacionEditar){
			setShrink(true);
			reset({
				...observacionEditar
			});
		}

	},[observacionEditar])


	return (
		<SingleFormBoxScene
			titlePage={titlePage}
			onCancel={() => {
				navigate(returnUrlObservaciones)
			}}
			onSave={handleSubmit(onSave)}
		>
			<CustomTextField
				label="Nombre Observacion"
				name="nombre_observacion"
				control={form.control}
				defaultValue={form.getValues().nombre_observacion || ''}
				error={errors.nombre_observacion}
				helperText={errors.nombre_observacion?.message ?? ''}
				shrink={shrink}
				onChangeValue={(v)=>{
					console.log('value',v)
				}}
			/>
			<CustomAutocomplete<Responsablev2> 
					label = "Responsable"
					name = "responsable_observacion"
					//opciones
					options={responsablePaginRes?.data.data || []}
					valueKey='tipo_responsable'
					actualValueKey='id_responsable'
					defaultValue={form.getValues().codigo|| ''}
       				optionLabelForEdit={form.getValues().responsable_data?.tipo_responsable || ''}
        			isLoadingData={isLoading}

					control={form.control}
					error={errors.responsable_data?.tipo_responsable}
					helperText={errors.codigo?.message}
					size={gridSizeMdLg6}
			/>
			<CustomTextField
				label="Descripcion"
				name="descripcion"
				control={form.control}
				defaultValue={form.getValues().descripcion || ''}
				error={errors.descripcion}
				helperText={errors.descripcion?.message ?? ''}
				shrink={shrink}
			/>
		</SingleFormBoxScene>
	);
};
export default SaveObservacion;
